<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="网站logo">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="logo()"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="logo">
          <img :src="form.logo" alt />
        </div>
      </el-form-item>
      <el-form-item label="轮播图">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="banner()"
          :file-list="form.banner"
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div></div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确认修改</el-button>
        <el-button @click="goback">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        logo: "http://res.sjzqcrl.com/banner1.png",
        banner: [
          {
            id:'1',
            name: "food.jpeg",
            url: "http://res.sjzqcrl.com/banner1.png"
          },
          {
            id:'2',
            name: "food2.jpeg",
            url: "http://res.sjzqcrl.com/banner1.png"
          }
        ]
      }
    };
  },
  methods: {
    logo() {},
    banner() {},
    remove(file, fileList) {
      console.log(file);
      console.log(fileList);
      console.log(this.form.banner);
    },
    onSubmit() {
      console.log("submit!");
    },
    goback(){
      this.$router.push('/admin/index/onepage')
    }
  }
};
</script>

<style lang="less" scoped> 
.logo{
  width: 20%;
  margin-top: 20px;
  img{
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/onepage/header.vue